import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-custom-price-dialog',
  templateUrl: './custom-price-dialog.component.html',
  styleUrls: ['./custom-price-dialog.component.scss']
})
export class CustomPriceDialogComponent {
  public title: string;
  public originalPrice: number;
  public customPrice: number;
  public maxPrice: number | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<CustomPriceDialogComponent>
  ) {
    this.title = data.title;
    this.originalPrice = data.originalPrice;
    this.customPrice = data.customPrice;
    this.maxPrice = data.maxPrice || null;
  }

  isValidNumber(value: any): boolean {
    const twoDecimalRegex = /^\d*\.?\d{0,2}$/;
    const numValue = String(value);
    return value !== null &&
      value !== undefined &&
      !isNaN(Number(value)) &&
      value > 0 &&
      twoDecimalRegex.test(numValue);
  }

  formatAmount() {
    this.validateMaxValue(this.customPrice);
    if (this.customPrice) {
      // Round to 2 decimal places
      this.customPrice = Math.round(this.customPrice * 100) / 100;
    }
    this.changeDetectorRef.detectChanges();
  }

  updateCustomPrice() {
    // console.log('updateCustomPrice', typeof this.customPrice);
    if (typeof this.customPrice === 'string') {
      this.customPrice = parseFloat(this.customPrice);
    }
    this.dialogRef.close({action: 'update', value: this.customPrice});
  }

  removeCustomPrice() {
    this.dialogRef.close({action: 'remove'});
  }

  close() {
    this.dialogRef.close();
  }

  validateMaxValue(event: number) {
    // console.log('validateMaxValue', event,this.maxPrice,this.customPrice);
    if (this.maxPrice && event > this.maxPrice) {
      this.customPrice = this.maxPrice;
    } else {
      this.customPrice = event;
    }
    this.changeDetectorRef.detectChanges();
  }
}
